<template>
  <v-container fluid class="fill-height d-block">
    <Loading v-if="loading" />
    <v-row v-else>
      <v-col cols="12" md="6">
        <div class="align-self-start fill-width pa-2">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            class="theme-custom-input fill-width"
            v-model="commissionModel.commissionType"
            :items="commissionTypes"
            :label="
              $t(
                'panel.currencyManagementPage.currencySettingsPage.commissionType'
              )
            "
            dense
            filled
          />
          <v-form
            @submit.prevent="updateCurrencyCommission"
            ref="CurrencyCommission"
          >
            <v-text-field
              v-model="commissionModel.percentage"
              :disabled="commissionModel.commissionType === 'DEFAULT'"
              :rules="commissionRules"
              v-separator="{ dot: true }"
              required
              :label="
                $t(
                  'panel.currencyManagementPage.currencySettingsPage.commissionPercentage'
                )
              "
              filled
              dense
              class="theme-custom-input fill-width"
            >
            </v-text-field>

            <v-btn
              depressed
              color="primary"
              :loading="commissionLoading"
              type="submit"
            >
              {{ $t("panel.currencyManagementPage.currencySettingsPage.save") }}
            </v-btn>
          </v-form>
        </div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="align-self-start fill-width pa-2">
          <v-form @submit.prevent="updateCurrencyRange" ref="CurrencyRange">
            <v-text-field
              v-model="currencyRangeModel.minAmount"
              :rules="minAmountRules"
              v-separator="{ dot: true, separator: true }"
              required
              :label="
                $t(
                  'panel.currencyManagementPage.currencySettingsPage.minAmount'
                )
              "
              filled
              dense
              class="theme-custom-input fill-width"
            >
            </v-text-field>

            <v-text-field
              v-model="currencyRangeModel.maxAmount"
              :rules="maxAmountRules"
              v-separator="{ dot: true, separator: true }"
              required
              :label="
                $t(
                  'panel.currencyManagementPage.currencySettingsPage.maxAmount'
                )
              "
              filled
              dense
              class="theme-custom-input fill-width"
            >
            </v-text-field>

            <v-btn
              depressed
              color="primary"
              :loading="amountLoading"
              type="submit"
            >
              {{ $t("panel.currencyManagementPage.currencySettingsPage.save") }}
            </v-btn>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { separatorFilter } from "@/plugins/mask-separator";
import { currenciesService } from "@/services";
import Loading from "@/components/Common/Loading";

export default {
  name: "add-currency",
  components: { Loading },
  props: ["currencyId"],
  data() {
    return {
      loading: false,
      commissionLoading: false,
      amountLoading: false,
      commissionTypes: ["DEFAULT", "MANUAL"],
      commissionModel: {
        commissionType: "DEFAULT",
        cryptoCurrencyId: "",
        percentage: 0
      },
      currencyRangeModel: {
        id: 0,
        maxAmount: 0,
        minAmount: 0
      },
      commissionRules: [
        v =>
          !!v ||
          this.$t("panel.currencyManagementPage.currencySettingsPage.notEmpty"),
        v =>
          +v <= 100 ||
          this.$t(
            "panel.currencyManagementPage.currencySettingsPage.notValidPercentage"
          )
      ],
      minAmountRules: [
        v =>
          !!v ||
          this.$t("panel.currencyManagementPage.currencySettingsPage.notEmpty")
      ],
      maxAmountRules: [
        v =>
          !!v ||
          this.$t("panel.currencyManagementPage.currencySettingsPage.notEmpty"),
        v =>
          +v.toString().replace(/,/g, "") >=
            +this.currencyRangeModel.minAmount.toString().replace(/,/g, "") ||
          this.$t(
            "panel.currencyManagementPage.currencySettingsPage.notValidMaxAmount"
          )
      ]
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      currenciesService
        .getCryptoCurrency(this.currencyId)
        .then(res => {
          this.commissionModel.commissionType = res.data.commissionType;
          this.commissionModel.percentage = res.data.commission;
          this.currencyRangeModel.maxAmount = separatorFilter(
            res.data.maxAmount,
            { dot: true, separator: true }
          );
          this.currencyRangeModel.minAmount = separatorFilter(
            res.data.minAmount,
            { dot: true, separator: true }
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateCurrencyCommission() {
      if (!this.$refs.CurrencyCommission.validate()) {
        return;
      }
      this.commissionModel.cryptoCurrencyId = this.currencyId;
      this.commissionLoading = true;
      currenciesService
        .updateCurrencyCommission(this.commissionModel)
        .then(res => {
          this.$toast.success(res.data.message);
        })
        .finally(() => {
          this.commissionLoading = false;
        });
    },
    updateCurrencyRange() {
      if (!this.$refs.CurrencyRange.validate()) {
        return;
      }
      this.currencyRangeModel.id = this.currencyId;
      this.currencyRangeModel.minAmount = +this.currencyRangeModel.minAmount.replace(
        /,/g,
        ""
      );
      this.currencyRangeModel.maxAmount = +this.currencyRangeModel.maxAmount.replace(
        /,/g,
        ""
      );
      this.amountLoading = true;
      currenciesService
        .updateCurrencyAmountRange(this.currencyRangeModel)
        .then(res => {
          this.$toast.success(res.data.message);
        })
        .finally(() => {
          this.amountLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
